import styled from "styled-components";


export const ProductsContainer = styled.div`
width: 100%;
min-height: 100vh;

@media (min-width: 900px){
    width: calc(100% - 330px);
    margin-left: auto;
}
`